/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PostApiPublicAppointment$Params {

/**
 * The appointment uuid
 */
  uuid: string;
  '_locale': 'de' | 'en' | 'fr';
      body: any
}

export function postApiPublicAppointment(http: HttpClient, rootUrl: string, params: PostApiPublicAppointment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, postApiPublicAppointment.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.path('_locale', params['_locale'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

postApiPublicAppointment.PATH = '/api/public/{_locale}/appointments/{uuid}';
